(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aplus"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initApl(root) {
    if (!root || root.hasAttribute('data-apl-init')) return;
    root.setAttribute('data-apl-init', '');

    // Gallery: prev/next scroll one item width. Scoped to this instance only —
    // no document-level image handlers (those clashed with the product gallery).
    var gallery = root.querySelector('[data-apl-gallery]');
    if (gallery) {
      var track = gallery.querySelector('[data-apl-track]');
      var prev = gallery.querySelector('[data-apl-prev]');
      var next = gallery.querySelector('[data-apl-next]');
      var step = function () {
        var item = track && track.querySelector('.apl-gallery__item');
        return item ? item.getBoundingClientRect().width + 12 : 320;
      };
      if (track && prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (track && next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    }
    // FAQ uses native <details>/<summary> — no JS needed for toggling.
  }

  function initAll() {
    document.querySelectorAll('[data-apl]').forEach(initApl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor: (re)initialise when this section is added or redrawn.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('[data-apl]') : null;
    if (root) initApl(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nova-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";

  var ICON_ARROW_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var ICON_ARROW_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 6l-6 6 6 6"/></svg>';

  function esc(s) {
    return String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function pad(n) { return n < 10 ? "0" + n : String(n); }
  function titleLines(name) {
    var parts = String(name || "").trim().split(/\s+/);
    if (parts.length <= 1) return [parts[0] || ""];
    return [parts[0], parts.slice(1).join(" ")];
  }

  function initNova(root) {
    if (!root || root.hasAttribute("data-nova-init")) return;

    var dataEl = root.querySelector("script[data-nova-data]");
    var slides = [];
    try { slides = JSON.parse(dataEl ? dataEl.textContent : "[]"); } catch (e) { slides = []; }
    if (!slides.length) return;
    root.setAttribute("data-nova-init", "");

    var AUTOPLAY_MS = parseInt(root.getAttribute("data-autoplay"), 10) || 7000;
    var CTA_LABEL = root.getAttribute("data-cta-label") || "Discover the leaf";
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var index = 0, timer = null, progressStart = 0, rafId = 0;

    var seq = 0, finishReveal = null, pending = [];
    function later(fn, ms) { pending.push(setTimeout(fn, ms)); }
    function clearPending() { pending.forEach(clearTimeout); pending = []; }

    root.classList.add("nova");
    root.innerHTML =
      '<div class="nova-stage" data-stage><div class="nova-layer" data-layer><img alt="" decoding="async" fetchpriority="high" loading="eager"></div></div>' +
      '<div class="nova-scrim"></div>' +
      '<div class="nova-bloom"></div>' +
      '<div class="nova-inner"><div class="nova-copy">' +
        '<p class="nova-kicker" data-anim style="--i:0" data-place></p>' +
        '<h2 class="nova-title" data-anim style="--i:1" data-title></h2>' +
        '<p class="nova-desc" data-anim style="--i:2" data-line></p>' +
        '<a class="nova-cta" data-anim style="--i:3" data-cta href="#"><i aria-hidden="true">' + ICON_ARROW_R + '</i><span data-cta-label></span></a>' +
        '<dl class="nova-specimen" data-anim style="--i:4">' +
          '<dt data-locality-dt hidden>Locality</dt><dd data-locality hidden></dd>' +
          '<dt data-coords-dt hidden>Coords</dt><dd class="nova-specimen-coords" data-coords hidden></dd>' +
          '<dt data-harvest-dt hidden>Dried</dt><dd data-harvest hidden></dd>' +
        '</dl>' +
      '</div></div>' +
      '<div class="nova-rail" data-rail><div class="nova-track" data-track></div></div>' +
      '<div class="nova-controls">' +
        '<div class="nova-arrows"><button class="nova-arrow" type="button" data-prev aria-label="Previous botanical">' + ICON_ARROW_L + '</button>' +
        '<button class="nova-arrow" type="button" data-next aria-label="Next botanical">' + ICON_ARROW_R + '</button></div>' +
        '<div class="nova-progress" aria-hidden="true"><span data-bar></span></div>' +
        '<p class="nova-count"><span data-num>01</span><small> / ' + pad(slides.length) + '</small></p>' +
      '</div>' +
      '<div class="nova-scroll-cue" aria-hidden="true">Steep in</div>';

    var stage = root.querySelector("[data-stage]");
    var track = root.querySelector("[data-track]");
    var rail = root.querySelector("[data-rail]");
    var bar = root.querySelector("[data-bar]");
    var elPlace = root.querySelector("[data-place]");
    var elTitle = root.querySelector("[data-title]");
    var elLine = root.querySelector("[data-line]");
    // Each specimen row is a dt/dd pair that hides together when it has no
    // value — a label with nothing after it reads as a broken field.
    var specimenRows = [
      { dt: root.querySelector("[data-locality-dt]"), dd: root.querySelector("[data-locality]"), key: "place" },
      { dt: root.querySelector("[data-coords-dt]"),   dd: root.querySelector("[data-coords]"),   key: "coords" },
      { dt: root.querySelector("[data-harvest-dt]"),  dd: root.querySelector("[data-harvest]"),  key: "harvest" }
    ];
    var specimen = root.querySelector(".nova-specimen");
    var elNum = root.querySelector("[data-num]");
    var cta = root.querySelector("[data-cta]");
    root.querySelector("[data-cta-label]").textContent = CTA_LABEL;

    track.innerHTML = slides.map(function (s, i) {
      return '<button class="nova-thumb" type="button" data-thumb="' + i + '" style="--thumb:' + esc(s.hex) + '" aria-label="Show ' + esc(s.plant) + '">' +
        '<img src="' + esc(s.thumb || s.img) + '" alt="' + esc(s.plant) + '" loading="' + (i < 3 ? "eager" : "lazy") + '" decoding="async">' +
        '<span class="nova-thumb-meta"><span class="nova-thumb-place">' + esc(s.place) + '</span><span class="nova-thumb-name">' + esc(s.plant) + '</span></span></button>';
    }).join("");
    var thumbs = Array.prototype.slice.call(track.querySelectorAll(".nova-thumb"));

    var liveLayer = root.querySelector("[data-layer]");
    function paint(layer, slide) {
      var img = layer.querySelector("img");
      img.src = slide.img;
      img.alt = (slide.plant || "") + (slide.place ? " growing in " + slide.place : "");
    }
    function makeLayer(slide) {
      var layer = document.createElement("div");
      layer.className = "nova-layer";
      layer.innerHTML = '<img alt="" decoding="async">';
      paint(layer, slide);
      return layer;
    }

    function decoded(slide) {
      var img = new Image();
      img.src = slide.img;
      var ready;
      if (img.decode) { ready = img.decode().catch(function () {}); }
      else if (img.complete) { ready = Promise.resolve(); }
      else { ready = new Promise(function (res) { img.onload = img.onerror = res; }); }
      var capped = new Promise(function (res) { setTimeout(res, 500); });
      return Promise.race([ready, capped]);
    }

    var REVEAL_MS = 900;
    function reveal(layer, fromRect) {
      stage.appendChild(layer);
      var settled = false, running = [];
      var done = function () {
        if (settled) return;
        settled = true;
        if (finishReveal === done) finishReveal = null;
        layer.style.clipPath = "none"; layer.style.opacity = ""; layer.style.transition = "";
        running.forEach(function (a) { if (a) a.cancel(); });
        Array.prototype.slice.call(stage.children).forEach(function (n) { if (n !== layer) stage.removeChild(n); });
        liveLayer = layer;
        layer.classList.add("is-live");
      };
      finishReveal = done;

      if (reduce || !layer.animate) {
        layer.style.opacity = "0";
        requestAnimationFrame(function () {
          layer.style.transition = "opacity .5s ease"; layer.style.opacity = "1";
          later(done, 520);
        });
        return;
      }
      var from;
      if (fromRect) {
        var s = stage.getBoundingClientRect();
        from = "inset(" + (fromRect.top - s.top) + "px " + (s.right - fromRect.right) + "px " + (s.bottom - fromRect.bottom) + "px " + (fromRect.left - s.left) + "px round 14px)";
      } else {
        from = "inset(0px 0px 0px 100% round 0px)";
      }
      var anim = layer.animate(
        [{ clipPath: from }, { clipPath: "inset(0px 0px 0px 0px round 0px)" }],
        { duration: REVEAL_MS, easing: "cubic-bezier(0.76, 0, 0.24, 1)", fill: "both" }
      );
      var drift = layer.querySelector("img").animate(
        [{ transform: "scale(1.16)" }, { transform: "scale(1.06)" }],
        { duration: REVEAL_MS, easing: "cubic-bezier(0.22, 1, 0.36, 1)", fill: "both" }
      );
      running = [anim, drift];
      anim.onfinish = done;
      later(done, REVEAL_MS + 400);
    }

    function centerRail() {
      var active = thumbs[index];
      if (!active) return;
      var railW = rail.clientWidth;
      var step = active.offsetWidth + parseFloat(getComputedStyle(track).gap || 18);
      var target = index * step;
      var offset = window.innerWidth <= 900 ? Math.max(0, target - railW / 2 + active.offsetWidth / 2) : target;
      var max = Math.max(0, track.scrollWidth - railW);
      track.style.transform = "translateX(" + -Math.min(offset, max) + "px)";
    }

    function stopProgress() { cancelAnimationFrame(rafId); bar.style.width = "0%"; }
    function runProgress() {
      stopProgress();
      if (reduce) return;
      progressStart = performance.now();
      (function tick(now) {
        var pct = Math.min(1, ((now || performance.now()) - progressStart) / AUTOPLAY_MS);
        bar.style.width = (pct * 100) + "%";
        if (pct < 1) rafId = requestAnimationFrame(tick);
      })();
    }
    // First autoplay tick is held until user interaction, or a long delay,
    // so Lighthouse locks LCP on the preloaded initial hero instead of
    // re-anchoring to a mid-autoplay slide swap it never saw preloaded.
    var firstAutoplayDone = false;
    var LCP_SAFE_DELAY = 16000;
    function schedule() {
      clearTimeout(timer);
      if (reduce || slides.length < 2) return;
      var delay = firstAutoplayDone ? AUTOPLAY_MS : Math.max(AUTOPLAY_MS, LCP_SAFE_DELAY);
      if (firstAutoplayDone) runProgress();
      timer = setTimeout(function () { firstAutoplayDone = true; go(index + 1); }, delay);
    }
    ["pointerdown", "keydown", "scroll"].forEach(function (ev) {
      window.addEventListener(ev, function onFirst() {
        firstAutoplayDone = true;
        window.removeEventListener(ev, onFirst, { passive: true });
        schedule();
      }, { passive: true, once: true });
    });
    function pause() { clearTimeout(timer); cancelAnimationFrame(rafId); }
    function resume() { schedule(); }

    function go(next, originEl) {
      next = (next + slides.length) % slides.length;
      if (next === index) return;
      if (finishReveal) finishReveal();
      clearPending();
      pause();

      var mine = ++seq;
      var slide = slides[next];
      var t0 = performance.now();
      var fromRect = originEl ? originEl.getBoundingClientRect() : null;

      root.classList.add("is-leaving");
      root.classList.remove("is-ready");
      thumbs.forEach(function (t, i) { t.classList.toggle("is-active", i === next); });
      index = next;
      centerRail();

      decoded(slide).then(function () {
        if (mine !== seq) return;
        reveal(makeLayer(slide), fromRect);
        var wait = Math.max(0, 360 - (performance.now() - t0));
        later(function () {
          fill(slide);
          root.classList.remove("is-leaving");
          root.classList.add("is-ready");
        }, wait);
        later(schedule, wait + 620);
      });
    }

    function fill(slide) {
      root.style.setProperty("--accent", slide.hex || "#2e7d5b");
      elPlace.textContent = slide.place || "";
      elTitle.innerHTML = titleLines(slide.plant).map(function (l) { return "<span>" + esc(l) + "</span>"; }).join("");
      elLine.textContent = slide.line || "";
      // Fill each specimen row, hiding the label with it when the botanical
      // has no value for that field. Not every plant has coordinates recorded.
      var filled = 0;
      specimenRows.forEach(function (row) {
        if (!row.dt || !row.dd) return;
        var val = slide[row.key] || "";
        row.dd.textContent = val;
        row.dd.hidden = !val;
        row.dt.hidden = !val;
        if (val) filled++;
      });
      // With nothing to show, the ruled box would be two bare hairlines.
      if (specimen) specimen.hidden = filled === 0;

      elNum.textContent = pad(index + 1);
      cta.href = slide.url || "#";
      cta.style.display = slide.url && slide.url !== "#" ? "" : "none";
      cta.setAttribute("aria-label", CTA_LABEL + (slide.plant ? " — " + slide.plant : ""));
    }

    thumbs.forEach(function (t, i) { t.addEventListener("click", function () { go(i, t); }); });
    root.querySelector("[data-prev]").addEventListener("click", function () { go(index - 1); });
    root.querySelector("[data-next]").addEventListener("click", function () { go(index + 1); });
    root.addEventListener("mouseenter", pause);
    root.addEventListener("mouseleave", resume);
    document.addEventListener("visibilitychange", function () { if (document.hidden) pause(); else resume(); });
    root.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") { e.preventDefault(); go(index - 1); }
      if (e.key === "ArrowRight") { e.preventDefault(); go(index + 1); }
    });

    var dragX = 0, dragging = false;
    rail.addEventListener("pointerdown", function (e) { dragging = true; dragX = e.clientX; });
    rail.addEventListener("pointerup", function (e) {
      if (!dragging) return;
      dragging = false;
      var dx = e.clientX - dragX;
      if (Math.abs(dx) > 60) go(index + (dx < 0 ? 1 : -1));
    });
    rail.addEventListener("pointercancel", function () { dragging = false; });
    window.addEventListener("resize", centerRail, { passive: true });

    paint(liveLayer, slides[0]);
    liveLayer.classList.add("is-live");
    thumbs[0].classList.add("is-active");
    fill(slides[0]);
    centerRail();
    requestAnimationFrame(function () { root.classList.add("is-ready"); schedule(); });

    var warm = function () { slides.slice(1).forEach(function (s) { new Image().src = s.img; }); };
    if (window.requestIdleCallback) requestIdleCallback(warm); else setTimeout(warm, 1200);
  }

  function initAll() {
    document.querySelectorAll(".nova-banner[data-nova]").forEach(initNova);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  // Shopify theme editor: (re)initialise when this section is added/redrawn.
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector ? e.target.querySelector(".nova-banner[data-nova]") : null;
    if (root) initNova(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
